module.exports = __webpack_public_path__ + "img/logo.77b70f11.svg";